export {
  condensedPriceTemplate,
  budgetSummary,
  materialPriceTemplate
}

const condensedPriceTemplate = {
  id: 'pricing_summary',
  name: 'Pricing Summary',
  type: 'pricing',
  subsections: []
}

const budgetSummary = { 
  id: 'budget_summary',
  form: {
    component: 'VRichText',
    bind: {
      placeholder: 'Budget summary',
      rows: 3
    }
  },
  display: {
    component: 'p'
  },
  value: 'Total base price to {SUPPLY_INSTALL} {TOTAL_SQFT_PER_TYPE} with {CONDENSED_INSTALLATION_METHODS} is {TOTAL_PRICE}'
}

const materialPriceTemplate = [
  {
    id: 'header',
    form: {
      component: 'VRichTextRenderer'
    },
    value: ''
  },
  { 
    id: 'content',
    display: {
      component: 'PricingSummaryCondensed',
      bind: {
        estimationItemId: null
      }
    },
    value: ''
  },
  { 
    id: 'notes',
    form: {
      component: 'VTextArea',
      bind: {
        placeholder: 'Notes',
        rows: 3
      }
    },
    display: {
      component: 'p'
    },
    value: '  '
  },
  {
    id: 'generic_estimated_timeline',
    display: {
      component: 'img',
      bind: {
        src: 'http://api.camas.app/static/images/images/image__34b91f24549091acd1c6ef752a3598c7.png'
      }
    },
    value: ''
  }
]